import { getBaseUrl, getRequestWithTokenInformation } from "services/common";
import { RequestInit } from "atoms/models";

export const getAddressSearchPage = async () => {
  const baseUrl = getBaseUrl();
  const relativeUrl = "ecommerce/route/addressSearchPage";
  const input = new URL(relativeUrl, baseUrl).href;
  const init: RequestInit = getRequestWithTokenInformation("GET");
  const response = await window.fetch(input, init);
  if (!response.ok) {
    throw new Error();
  } else {
    const json = await response.json();
    return json;
  }
};
